import { ClientTypes, GrantTypes } from '../api/configurations/oauth2/types';

export const getOAuthType = (access: GrantTypes[], isPublic: boolean): ClientTypes => {
  if (access.includes(GrantTypes.client_credentials) && !!access.length) {
    return ClientTypes.server;
  }
  if (isPublic) {
    return ClientTypes.public;
  }
  return ClientTypes.confidential;
};
